import overcast from "../Assets/AllCloudSvg/overcast.png";
import partlyCloud from "../Assets/AllCloudSvg/partlyCloud.png";
import mostlyCloud from "../Assets/AllCloudSvg/mostlyCloud.png";
import clearSky from "../Assets/AllCloudSvg/clearSky.png";
import normalRain from "../Assets/AllCloudSvg/normalRain.png";
import sunny from "../Assets/AllCloudSvg/sunny.png";
import windy from "../Assets/AllCloudSvg/windy.png";
import drizzle from "../Assets/AllCloudSvg/drizzle.png";

export default function logoAndTitleFunction(el) {
  // Windy condition (no rain, high wind speed)
  if (Math.trunc(el.Rainfall) === 0 && Math.trunc(el.Wind_Speed) >= 15) {
    return {
      logo: windy,
      title: 'Windy',
    };
  }

  // Clear Sky (no rain, no low clouds)
  if (Math.trunc(el.Rainfall) === 0 && Math.trunc(el.Lowcloud) === 0) {
    return {
      logo: clearSky,
      title: 'Clear Sky',
    };
  }

  // Rainfall conditions based on the image categories
  const rainfall = el.Rainfall;

  // No rain
  if (rainfall === 0.0) {
    // This will be handled by other conditions (clear sky, sunny, etc.)
  }

  // Trace rain (0.01 - 0.1 mm)
  if (rainfall >= 0.01 && rainfall <= 0.1) {
    return {
      logo: normalRain,
      title: 'Trace Rain',
    };
  }

  // Very light rain (0.1 - 2.5 mm)
  if (rainfall > 0.1 && rainfall <= 2.5) {
    return {
      logo: normalRain,
      title: 'Very Light Rain',
    };
  }

  // Light rain (2.5 - 7.5 mm)
  if (rainfall > 2.5 && rainfall <= 7.5) {
    return {
      logo: normalRain,
      title: 'Light Rain',
    };
  }

  // Moderate rain (7.5 - 35.5 mm)
  if (rainfall > 7.5 && rainfall <= 35.5) {
    return {
      logo: normalRain,
      title: 'Moderate Rain',
    };
  }

  // Rather heavy rain (35.5 - 64.4 mm)
  if (rainfall > 35.5 && rainfall <= 64.4) {
    return {
      logo: normalRain,
      title: 'Rather Heavy Rain',
    };
  }

  // Heavy rain (64.4 - 124.4 mm)
  if (rainfall > 64.4 && rainfall <= 124.4) {
    return {
      logo: normalRain,
      title: 'Heavy Rain',
    };
  }

  // Very heavy rain (124.4 - 244.4 mm)
  if (rainfall > 124.4 && rainfall <= 244.4) {
    return {
      logo: normalRain,
      title: 'Very Heavy Rain',
    };
  }

  // Extremely heavy rain (≥ 244.4 mm)
  if (rainfall > 244.4) {
    return {
      logo: normalRain,
      title: 'Extremely Heavy Rain',
    };
  }

  // Cloud conditions (when no rain)
  if (Math.trunc(el.Rainfall) === 0) {
    // Sunny Day (high temperature, low clouds)
    if (Math.trunc(el.Tmax) > 25 && (Math.trunc(el.Lowcloud) === 0 || Math.trunc(el.Lowcloud) <= 10)) {
      return {
        logo: sunny,
        title: 'Sunny Day',
      };
    }

    // Partial Cloud (10-50% low clouds)
    if (Math.trunc(el.Lowcloud) > 10 && Math.trunc(el.Lowcloud) < 50) {
      return {
        logo: partlyCloud,
        title: 'Partial Cloud',
      };
    }

    // Mostly Cloud (50-80% low clouds)
    if (Math.trunc(el.Lowcloud) >= 50 && Math.trunc(el.Lowcloud) < 80) {
      return {
        logo: mostlyCloud,
        title: 'Mostly Cloud',
      };
    }

    // Overcast (≥80% low clouds)
    if (Math.trunc(el.Lowcloud) >= 80) {
      return {
        logo: overcast,
        title: 'Overcast',
      };
    }
  }

  return {};
};